import {
  BorrowerOnboardingDetails,
  CardId,
  DATE_FORMAT,
  formatDate,
  NationalityPeriod,
} from '@nemuru-eng/js-api-client';

import {
  isNieDocumentType,
  isNieEuDocumentType,
} from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/_shared/utils/nieDocumentTypes.utils';
import {
  NIE_EU_CARD_ID,
  NIE_EU_EXPIRATION_DATE_CARD_DATE,
} from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/_shared/constants/nieEuData.constants';
import { BorrowerOnboardingDetailsFormType } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/PaymentIntent/Multilender/MerchantPos/MerchantPosForm/components/BorrowerOnboardingDetailsForm/schemas/borrowerOnboardingDetailsForm.schema';
import { NieDataFormType } from '@/components/modules/KYC/KYCLoan/BorrowerKYC/components/DocumentIdSection/schemas/nieDataForm.schema';

export const mapFormValuesToStoredNieData = (
  formValues: BorrowerOnboardingDetailsFormType,
  existingNieData?: NonNullable<BorrowerOnboardingDetails['nieData']>,
): NonNullable<BorrowerOnboardingDetails['nieData']> | undefined => {
  if (!isNieDocumentType(formValues.documentType)) {
    return undefined;
  }

  const { nationalityPeriod, cardId, expirationDateCard, socialSecurityDate, numberOfWork } = formValues;

  if (nationalityPeriod == null || socialSecurityDate == null || numberOfWork == null) {
    return undefined;
  }

  if (isNieEuDocumentType(formValues.documentType)) {
    return {
      id: existingNieData?.id ?? '',
      nationalityPeriod,
      cardId: NIE_EU_CARD_ID,
      expirationDateCard: NIE_EU_EXPIRATION_DATE_CARD_DATE,
      socialSecurityDate: formatDate(socialSecurityDate, DATE_FORMAT.YYYY_MM_DD) as unknown as Date,
      numberOfWork,
    };
  }

  if (cardId == null || expirationDateCard == null) {
    return undefined;
  }

  return {
    id: existingNieData?.id ?? '',
    nationalityPeriod,
    cardId,
    expirationDateCard: formatDate(expirationDateCard, DATE_FORMAT.YYYY_MM_DD) as unknown as Date,
    socialSecurityDate: formatDate(socialSecurityDate, DATE_FORMAT.YYYY_MM_DD) as unknown as Date,
    numberOfWork,
  };
};

export const getNieDataFormDisplayValues = (
  formValues: Partial<NieDataFormType>,
): NonNullable<BorrowerOnboardingDetails['nieData']> => ({
  id: '',
  nationalityPeriod: formValues.nationalityPeriod ?? NationalityPeriod.UNKNOWN,
  cardId: formValues.cardId ?? CardId.INITIAL,
  expirationDateCard: formValues.expirationDateCard ? new Date(formValues.expirationDateCard) : new Date(),
  socialSecurityDate: formValues.socialSecurityDate ? new Date(formValues.socialSecurityDate) : new Date(),
  numberOfWork: formValues.numberOfWork as number,
});
